@if (breakpointChanges | async; as breakpointState) {
  <button tdWbIconButton
          [tdWbIconButtonShape]="breakpointState.matches && autoSizeOverride() ? 'circle' : 'square'"
          tdWbIconButtonSize="small"
          [tdWbIconButtonLabelText]="'tdWb.component.toolbar.PRINT' | tdWbTranslate"
          [tdWbIconButtonBackground]="(breakpointState.matches && autoSizeOverride() ? 'clear' : tdWbIconButtonBackground())"
          [attr.title]="'tdWb.component.toolbar.PRINT' | tdWbTranslate"
          [attr.aria-label]="'tdWb.component.toolbar.PRINT' | tdWbTranslate"
          (click)="print()">
    <td-wb-icon size="18" iconId="printer--small" />
    <ng-content />
  </button>
}

